// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Menu_menu__vtl5e {
  width: fit-content;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  top: -60px;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 137px;
}
.Menu_menu__vtl5e li {
  width: 20px;
  height: 20px;
  list-style-type: none;
  background-color: #d8d8ff;
  color: #FFFFFF;
  display: inline-block;
  border-radius: 50%;
  position: relative;
  text-align: center;
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  cursor: default;
}
.Menu_menu__vtl5e li span {
  position: absolute;
  color: #d8d8ff;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  font-weight: 400;
}
.Menu_menu__vtl5e li:not(:first-child):before {
  content: "";
  width: 129px;
  height: 1px;
  display: inline-block;
  background-color: #d8d8ff;
  margin: auto 4px;
  position: absolute;
  top: 10px;
  right: 20px;
}
.Menu_menu__vtl5e li.Menu_active__H98mL {
  background-color: #0000c9;
}
.Menu_menu__vtl5e li.Menu_active__H98mL:before {
  background-color: #0000c9;
}
.Menu_menu__vtl5e li.Menu_active__H98mL span {
  color: #00007a;
}

@media screen and (max-width: 765px) {
  .Menu_menu__vtl5e {
    gap: calc((100vw - 80px - 274px) / 3);
  }
  .Menu_menu__vtl5e li:not(:first-child):before {
    width: calc((100vw - 80px - 32px - 274px) / 3);
  }
}
@media screen and (max-width: 600px) {
  .Menu_menu__vtl5e {
    top: -10px;
    gap: calc((100vw - 80px - 40px) / 3);
  }
  .Menu_menu__vtl5e li:not(:first-child):before {
    width: calc((100vw - 80px - 32px - 40px) / 3);
  }
  .Menu_menu__vtl5e span {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/components/Menu/Menu.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AAIJ;AAFI;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,yBCjBG;EDkBH,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAIR;AAFQ;EACI,kBAAA;EACA,cC9BD;ED+BC,SAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAIZ;AADQ;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,yBC3CD;ED4CC,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAGZ;AAAQ;EACI,yBC/CD;ADiDX;AAAY;EACI,yBClDL;ADoDX;AACY;EACI,cCpDL;ADqDX;;AAMA;EACI;IACI,qCAAA;EAHN;EAMU;IACI,8CAAA;EAJd;AACF;AASA;EACI;IACI,UAAA;IACA,oCAAA;EAPN;EAUU;IACI,6CAAA;EARd;EAYM;IACI,aAAA;EAVV;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.menu{\n    width: fit-content;\n    position: relative;\n    left: 50%;\n    transform: translateX(-50%);\n    top: -60px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    gap: 137px;\n\n    li{\n        width: 20px;\n        height: 20px;\n        list-style-type: none;\n        background-color: colors.$primary2;\n        color: #FFFFFF;\n        display: inline-block;\n        border-radius: 50%;\n        position: relative;\n        text-align: center;\n        font-weight: 300;\n        font-size: 14px;\n        line-height: 20px;\n        cursor: default;\n\n        span{\n            position: absolute;\n            color: colors.$primary2;\n            top: 30px;\n            left: 50%;\n            transform: translateX(-50%);\n            font-size: 16px;\n            font-weight: 400;\n        }\n\n        &:not(:first-child):before{\n            content: '';\n            width: 129px;\n            height: 1px;\n            display: inline-block;\n            background-color: colors.$primary2;\n            margin: auto 4px;\n            position: absolute;\n            top: 10px;\n            right: 20px;\n        }\n\n        &.active{\n            background-color: colors.$primary6;\n\n            &:before{\n                background-color: colors.$primary6;\n            }\n\n            span{\n                color: colors.$primary8;\n            }\n        }\n    }\n}\n\n\n@media screen and (max-width: 765px) {\n    .menu{\n        gap: calc((100vw - (20px * 4) - (137px * 2)) / 3);\n\n        li{\n            &:not(:first-child):before{\n                width: calc((100vw - (20px * 4) - (4px * 2 * 4) - (137px * 2)) / 3);\n            }\n        }\n    }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n    .menu{\n        top: -10px;\n        gap: calc((100vw - (20px * 4) - (20px * 2)) / 3);\n\n        li{\n            &:not(:first-child):before{\n                width: calc((100vw - (20px * 4) - (4px * 2 * 4) - (20px * 2)) / 3);\n            }\n        }\n\n        span{\n            display: none;\n        }\n    }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"menu": `Menu_menu__vtl5e`,
	"active": `Menu_active__H98mL`
};
export default ___CSS_LOADER_EXPORT___;
